var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudList',{attrs:{"title":"Etiquetas","storeName":"Tags","labelAddNew":"Agregar","sortable":"","canSearch":"","next-link":"/admin/rent_trakers","breadcrumbs":[
    {
      text: 'Spots y vehículos',
      disabled: false,
      href: '/admin/tags'
    },
    {
      text: 'Etiquetas',
      disabled: false,
      href: '#'
    },
  ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }